module.exports = __webpack_public_path__ + "static/media/58.ac55bd05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/58.jpg
// module id = 591
// module chunks = 0